import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import React from 'react'

function LoadingIcon({ size }) {
  return (
    <div className="loading-icon text-center">
      <FontAwesomeIcon
        size={size}
        icon="spade"
        fixedWidth
        className="black suit"
      />
      <FontAwesomeIcon
        size={size}
        icon="heart"
        fixedWidth
        className="red suit text-success"
      />
      <FontAwesomeIcon
        size={size}
        icon="club"
        fixedWidth
        className="black suit"
      />
      <FontAwesomeIcon
        size={size}
        icon="diamond"
        fixedWidth
        className="red suit text-success"
      />
    </div>
  )
}

LoadingIcon.propTypes = {
  size: PropTypes.string,
}

LoadingIcon.defaultProps = {
  size: '2x',
}

export default LoadingIcon
